import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getSubscriptionRescheduleStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.RESCHEDULE_SUBSCRIPTION);

export default getSubscriptionRescheduleStatus;
